import React, { useState, useEffect } from 'react';
import api from '../services/api';
import PagamentoFatura from './PagamentoFatura';
import FaturaTelefonia from './FaturaTelefonia';

// Painel de faturas da telefonia (ciclo atual + fechadas + envio WhatsApp) - compartilhado entre telas - Neurotech-X 04/10/2026
export default function PainelFaturasTelefonia({ clienteId }) {
    const [fechadas, setFechadas] = useState([]);
    const [sel, setSel] = useState(null);
    const [aberta, setAberta] = useState(null);
    const [envio, setEnvio] = useState({});
    const [erro, setErro] = useState('');
    const rotuloMes = (f) => { const t = new Date(f.ciclo_inicio).toLocaleDateString('pt-BR', Object.assign({ month: 'long', year: 'numeric' }, f.timezone ? { timeZone: f.timezone } : {})); return t.charAt(0).toUpperCase() + t.slice(1); };
    const msgErro = (e) => (e && e.response && e.response.data && e.response.data.error) || (e && e.message) || 'erro desconhecido';
    const carregar = async (manter) => {
        setErro('');
        try { const r = await api.get('/api/billing/minutos/' + clienteId + '/faturas'); const l = r.data || []; setFechadas(l); setSel(prev => (manter && l.some(x => x.id === prev)) ? prev : (l.length ? l[0].id : null)); }
        catch (e) { setFechadas([]); setSel(null); setErro('Erro ao carregar as faturas: ' + msgErro(e)); }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { if (clienteId) carregar(); }, [clienteId]);
    const abrirAtual = async () => {
        setErro('');
        try { const r = await api.get('/api/billing/minutos/' + clienteId + '/extrato'); setAberta(Object.assign({}, r.data, { _pdfUrl: '/api/billing/minutos/' + clienteId + '/pdf' })); }
        catch (e) { setErro('Erro ao abrir a fatura do ciclo atual: ' + msgErro(e)); }
    };
    const abrirFechada = async (fid) => {
        setErro('');
        try { const r = await api.get('/api/billing/faturas/' + fid); setAberta(Object.assign({}, r.data, { _pdfUrl: '/api/billing/faturas/' + fid + '/pdf' })); }
        catch (e) { setErro('Erro ao abrir a fatura: ' + msgErro(e)); }
    };
    const enviar = async (f) => {
        if (envio.id === f.id && envio.fase === 'confirmar') {
            setEnvio({ id: f.id, fase: 'enviando' });
            let falha = '';
            try { await api.post('/api/billing/faturas/' + f.id + '/enviar-whatsapp'); } catch (e) { falha = 'Falha ao enviar: ' + msgErro(e); }
            setEnvio({});
            await carregar(true);
            if (falha) setErro(falha);
        } else {
            setEnvio({ id: f.id, fase: 'confirmar' });
        }
    };
    const f = fechadas.find(x => x.id === sel) || fechadas[0];
    const status = (x) => x.wa_status === 'falhou' ? ('✗ Falhou: ' + String(x.wa_erro || '').slice(0, 80)) : (x.wa_status ? ('✓ ' + x.wa_status.charAt(0).toUpperCase() + x.wa_status.slice(1) + (x.wa_enviada_em ? ' em ' + new Date(x.wa_enviada_em).toLocaleString('pt-BR') : '')) : 'Não enviada');
    const confirmando = f && envio.id === f.id && envio.fase === 'confirmar';
    return (
        <div>
            <button type="button" className="btn-ghost" style={{ padding: '6px 12px' }} onClick={abrirAtual}>Fatura do ciclo atual</button>
            <div style={{ marginTop: 12 }}>
                <label style={{ fontWeight: 600, fontSize: 13 }}>Faturas fechadas</label>
                {fechadas.length === 0 ? <p style={{ color: 'var(--text-muted)', fontSize: 12, marginTop: 2 }}>Nenhuma fatura fechada ainda.</p> : (
                    <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginTop: 6 }}>
                        <select value={sel || ''} onChange={e => setSel(e.target.value)} style={{ minWidth: 190 }}>
                            {fechadas.map(x => (<option key={x.id} value={x.id}>{rotuloMes(x) + (x.pago_em ? ' · paga' : ' · em aberto')}</option>))}
                        </select>
                        {f && (<React.Fragment>
                            <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{f.vencimento_txt ? 'Venc. ' + f.vencimento_txt + ' · ' : ''}{f.minutos} min · {f.ligacoes} ligações · <b>{Number(f.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></span>
                            <button type="button" className="btn-ghost" style={{ padding: '6px 12px' }} onClick={() => abrirFechada(f.id)}>Abrir / Baixar PDF</button>
                            <span title={f.wa_erro || ''} style={{ fontSize: 12, fontWeight: 600, color: f.wa_status === 'falhou' ? '#c0392b' : (f.wa_status ? '#1B9AAA' : 'var(--text-muted)') }}>{status(f)}</span>
                            {envio.id === f.id && envio.fase === 'enviando'
                                ? (<span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Enviando…</span>)
                                : (<button type="button" className="btn-ghost" style={Object.assign({ padding: '6px 12px' }, confirmando ? { borderColor: '#e67e22', color: '#e67e22' } : {})} onClick={() => enviar(f)}>{confirmando ? 'Confirmar envio por WhatsApp' : 'Enviar por WhatsApp'}</button>)}
                        </React.Fragment>)}
                    </div>
                )}
                {f && (<div style={{ marginTop: 8 }}><PagamentoFatura key={f.id} tipo="telefonia" fatura={f} onMudou={() => carregar(true)} /></div>)}
                {erro && <p style={{ color: '#c0392b', fontSize: 12, marginTop: 6 }}>{erro}</p>}
            </div>
            {aberta && <FaturaTelefonia dados={aberta} onClose={() => setAberta(null)} />}
        </div>
    );
}
